module.exports = __webpack_public_path__ + "images/tidings-bom-imag-new.1792033684119.png";